import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormText, Row, Col, Container, Label, FormGroup, } from 'reactstrap';
import AddIcon from 'react-icons/lib/md/library-add';
import { alertConstants, appConstants } from "../../_constants";
import { connect } from "react-redux";
import { alertActions, modalActions } from "../../_actions";
import DateSelector from '../utils/dateSelector';
import { apiActions } from "../../_actions/api.actions";
import { apiService, commonService } from "../../_services";
import billSummaryTemplate from '../../views/invoice/asset/billSummaryTemplate.xlsx';
import FileUpload from 'react-dropzone';
import FileIcon from 'react-icons/lib/md/cloud-upload';
import moment from "moment/moment";
import CheckIcon from 'react-icons/lib/md/info';
import { store } from '../../_helpers';

const fileUploadStyle = {
    width: "100%",
    paddingTop: "20px",
    paddingBottom: "20px",
    border: "1px dashed #aaa",
    borderRadius: "10px",
    cursor: 'pointer'
};

class IataHeaderContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            modalClass: '',
            formSuccess: false, //Error state mutable via Redux
            errorHeader: false, //Error state mutable via Redux
            successHeader: false, //Success message mutable via Redux
            componentErrorMessages: [],  //Errors generated within the component form
            componentError: false,  //Errors generated within the component
            processDate: new Date(),
            processFile: null,
            processFileName: '',
            isVGGUser: false
        };

    }
    componentDidMount() {
        const reduxState = store.getState();
        let { authentication } = reduxState;
        this.setState({ formSuccess: false })
        if (authentication.user !== undefined) {
            const { user } = authentication
            if (user.AviRole === appConstants.ROLES.VGG_SUPERADMIN || user.AviRole === appConstants.ROLES.VGG_USER) {
                this.setState({ isVGGUser: true })
            } else {
                this.setState({ isVGGUser: false })
            }
        }
    }
    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        const { modal } = nextProps;
        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                // this.setState({error: false, success: alert.message})
                this.setState({ errorHeader: false, successHeader: 'Operation successful' });
                this.resetForm();
            }
            else if (alert.type === alertConstants.CLEAR) {
                this.setState({ successHeader: false, errorHeader: false })

            } else {
                this.setState({ successHeader: false, errorHeader: false })
            }
        }
        if (modal) {
            if (modal.type === appConstants.OPEN_MODAL) {
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                })
            } else if (modal.type === appConstants.CLOSE_MODAL) {
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }
    };
    resetForm() {
        this.setState({ componentError: false, componentErrorMessages: [], processFile: null, processFileName: '', formSuccess: false });
        this.resetError();
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    };

    toggle = (e, modalClass) => {
        if (this.state.modal) {
            this.resetForm();
            this.props.dispatch(modalActions.close({ 'modalClass': modalClass }));
        } else {
            this.props.dispatch(modalActions.open({ 'modalClass': modalClass }));
        }
    };
    renderPageResponse() {
        if (this.state.componentError) {
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if (this.state.successHeader) {
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }
    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ isRequesting: true });
        this.resetError();
        if (this.validateInput()) {
            this.processSubmit();
        }
    };
    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.processDate === '') {
            _errs_['processDate'] = 'Please select process date';
            formValid = false;
        }
        if (this.state.processFileName === '') {
            _errs_['processFileName'] = 'Please upload process file';
            formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_ });
        return formValid;
    };
    onChange = (event) => {
        this.setState({ processFile: event.target.files[0] })
    };

    onDrop = (files) => {
        this.setState({ processFile: files[0], processFileName: files[0].name })
    };
    processSubmit = () => {
        const { processDate, processFile } = this.state;
        const payload = new FormData();
        payload.append('ProcessDate', moment(processDate).format("DD MM YYYY"));
        payload.append('File', processFile);

        const { dispatch } = this.props;
        dispatch(apiActions.startRequest());

        commonService.uploadBillingSummary(payload)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        this.setState({ formSuccess: true });
                        dispatch(apiActions.endRequest());
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        const err_msg = response.response.split("<br>");
                        // const err_msg = response.response.split("<br>");
                        dispatch(apiActions.endRequest());
                        this.setState({ errorHeader: err_msg });
                        // dispatch(alertActions.error(err_msg));
                    }
                }
            ).catch(
                error => {
                    let errorMessage = apiService.interpretErrorResponse(error);
                    dispatch(alertActions.error(errorMessage));
                    dispatch(apiActions.endRequest());
                }
            )
    };
    render() {
        let modalResponse = this.renderPageResponse();
        const { requesting, pageRequesting } = this.props;
        const { componentErrorMessages, processFileName, errorHeader, formSuccess, isVGGUser } = this.state;

        return (
            <div className="view-header d-flex align-items-center">
                <header className="text-white">
                    <h1 className="h5 title text-uppercase"> IATA Invoice</h1>
                    <p className="mb-0 subtitle text-nowrap">IATA Invoice Reconciliation</p>
                </header>
                {!isVGGUser && <div className="ml-auto d-flex mt-2">
                    <div className="hidden-sm-down">
                        <Button className="btn-avi-secondary" disabled={pageRequesting || requesting} onClick={(e) => this.toggle(e, 'modalSlideIn')}>
                            <AddIcon color="#ffffff" size="20" /> New Process
                        </Button>
                    </div>
                </div>}
                <Modal size={'md'} isOpen={this.state.modal} toggle={this.toggle} className={this.state.modalClass}>
                    <ModalHeader toggle={this.toggle}>New Process</ModalHeader>
                    <Form onSubmit={this.handleSubmit}>
                        <ModalBody>
                            {modalResponse}
                            {
                                (errorHeader) &&
                                <div className="alert alert-danger" style={{ paddingLeft: 0 }}>
                                    <ul>
                                        {errorHeader.map((item, i) => <li key={i}> {item} </li>)}
                                    </ul>
                                </div>
                            }
                            {
                                !formSuccess &&
                                <Container>
                                    <Row>
                                        <Col sm="12">
                                            <FormGroup className="mb-4">
                                                <Label>Process Date</Label>
                                                <DateSelector maxDate={new Date()} todayDate={(new Date()).toString()} name="startDate" onValueChange={(processDate) => this.setState({ processDate })} />
                                                {componentErrorMessages.processDate && <FormText color="danger"> {componentErrorMessages.processDate}</FormText>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <FileUpload onDrop={this.onDrop} style={fileUploadStyle}>

                                                <div className="text-center">
                                                    <FileIcon size="40" color="#43a8df" />

                                                    {!processFileName && <div>
                                                        <h5>Drag & drop billing summary file here</h5>
                                                        <p>or click to upload</p>
                                                        <FormText color="muted">
                                                            Only .xlsx files are accepted for upload.
                                                        </FormText>
                                                    </div>
                                                    }
                                                    {processFileName &&
                                                        <div>
                                                            <p>{processFileName}</p>
                                                        </div>
                                                    }
                                                </div>
                                            </FileUpload>
                                        </Col>
                                    </Row>
                                </Container>
                            }
                            {
                                formSuccess &&
                                <div className={'text-center'}>
                                    <CheckIcon size="70" />
                                    <h4 className={'text-center'}>Your file was sent successfully</h4>
                                </div>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <small>
                                <a href={billSummaryTemplate} download>Download Template</a>
                            </small>
                            {
                                !formSuccess &&
                                <Button className="btn-avi-primary" disabled={requesting}> Proceed </Button>
                            }
                            <Button color="secondary" onClick={this.toggle}>Close</Button>
                        </ModalFooter>
                    </Form>
                    {requesting && <div className={'loading-dot active'}></div>}

                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { modal, alert } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
    };
}
export default connect(mapStateToProps)(IataHeaderContent);



// WEBPACK FOOTER //
// ./src/views/invoice/view-header.js